import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'

const Shipping = () => {
    return (
        <>
            <Header />
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft" style={{width:"100%"}}>
                        <h2>Shipping and Delivery</h2>
                    </div>
                    {/* <div className="osRight">
                        <p style={{ marginBottom: "0px" }} >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

                    </div> */}
                </div>
            </section>
            <section className='blogContentArea'>

                <div className="container">

                    <div className="blogContent">
                        <p>
                        Last updated: December 17, 2024

                        </p>
                        <p>
                        At I-LINE.AI SOLUTIONS PRIVATE LIMITED ("the Company"), we are committed to providing 
efficient and reliable shipping and delivery services through our platform, iLine.ai. This Shipping 
and Delivery Policy outlines the terms and conditions governing the transportation of goods 
arranged through our platform. By using our services, you agree to the terms stated below.
                        </p>
                    </div>
                    <div className="blogContent">
                        <h2>Scope of Shipping Services
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Service Description:</strong> The Company provides a logistics platform to connect Users with
                            transport providers for the shipment of consignments. While we facilitate these connections,
                            the actual transportation of goods is handled by third-party logistics partners.
                        </p>
                        <p>
                            <strong style={{ color: "#172039" }}>Service Coverage:</strong> Shipping services are available across designated locations in India.
                            Availability in specific regions may depend on the operational reach of our logistics partners.

                        </p>

                        <p>
                            <strong style={{ color: "#172039" }}>Service Limitations:</strong> The Company does not transport prohibited items, dangerous goods,
                            or any goods classified as illegal under applicable laws. Users must comply with all shipping
                            restrictions as outlined in the Terms and Conditions.
                        </p>

                    </div>
                    <div className="blogContent">
                        <h2>Booking and Delivery Process
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Consignment Booking:</strong> Users must provide accurate and complete information during the
                            booking process, including:
                        </p>
                        <ul>
                            <li>Pickup and delivery addresses.</li>
                            <li>Contact details of the sender and recipient.
                            </li>
                            <li>Nature, weight, and dimensions of the goods.</li>
                            <li>Special handling instructions, if any.</li>
                        </ul>
                        <p><strong style={{ color: "#172039" }}>Pickup Process:</strong></p>
                        <ul>
                            <li>Pickup times will be scheduled based on availability and User preferences.</li>
                            <li>The driver or logistics partner will verify the consignment details at the time of pickup.</li>
                            <li>Users must provide any required documentation for the consignment.</li>
                        </ul>
                        <p> <strong style={{ color: "#172039" }}>Delivery Process:</strong></p>
                        <ul className='Bullets'>
                            <li>The logistics partner will deliver the consignment to the address specified by the User.</li>
                            <li>Deliveries are deemed successful upon obtaining a recipient’s signature, digital
                                acknowledgment, or photo confirmation.</li>
                            <li>In case the recipient is unavailable, the logistics partner may attempt redelivery or
                                follow the instructions provided by the User.</li>
                        </ul>

                    </div>

                    <div className="blogContent">
                        <h2>Delivery Timelines
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Estimated Delivery Time:</strong> Delivery timelines vary depending on the distance, mode of
                            transportation, and other factors. Estimated delivery times will be communicated during the
                            booking process but actuals can change based on various factors not under control.
                        </p>
                        <p>
                            <strong style={{ color: "#172039" }}>Delays in Delivery:</strong> The Company will make reasonable efforts to ensure timely delivery.
                            However, delays may occur due to unforeseen circumstances such as traffic, weather,
                            technical issues, or force majeure events. The Company shall not be held liable for such
                            delays.

                        </p>

                    </div>

                    <div className="blogContent">
                        <h2>Fees and Charges
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Shipping Fees:</strong> Users agree to pay the shipping fees communicated at the time of booking.
                            Fees are determined based on factors such as distance, weight, dimensions, and additional
                            services requested.

                        </p>

                        <p>
                            <strong style={{ color: "#172039" }}>Additional Charges:</strong>
                        </p>
                        <ul>
                            <li>Charges may apply for tolls, remote locations, or special handling.</li>
                            <li>Charges will also apply for additional time consumed </li>
                            <li>Any additional costs incurred during transit will be communicated to the User and must
                                be settled promptly</li>
                        </ul>
                    </div>


                    <div className="blogContent">
                        <h2>Packaging Requirements
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>User Responsibility:</strong> Users are responsible for properly packaging their consignments to
                            ensure safe transportation.

                        </p>
                        <p>
                            <strong style={{ color: "#172039" }}>Prohibited Packaging Materials:</strong> The use of packaging materials deemed hazardous or
                            inappropriate for transportation is prohibited. The Company reserves the right to reject
                            consignments that are improperly packaged.
                        </p>

                    </div>

                    <div className="blogContent">
                        <h2>Tracking and Notifications</h2>
                        <p><strong style={{ color: "#172039" }}> Real-Time Tracking:</strong> Users can track their shipments in real-time through the iLine.ai 
                        platform.</p>
                        <p><strong style={{ color: "#172039" }}>Notifications:</strong> The Company will provide status updates via SMS, email, or app notifications 
                        at key stages of the delivery process, including pickup, transit, and delivery.</p>
                    </div>

                    <div className="blogContent">
                        <h2>Failed Deliveries
                        </h2>
                        <p> <strong style={{ color: "#172039" }}>Recipient Unavailability:</strong> If the recipient is unavailable at the delivery address, the logistics 
partner will attempt redelivery or contact the User for further instructions. Additional charges 
may apply for redelivery attempts.</p>
<p>
<strong style={{ color: "#172039" }}>Rejection of Consignment:</strong> If the recipient refuses to accept the consignment, the 
Company will contact the User for instructions. Users are responsible for any additional costs 
incurred for return, disposal, or redelivery of such consignments.
</p>
                    </div>

                    <div className="blogContent">
                        <h2> Liability and Insurance
                        </h2>
                        <p>
                        <strong style={{ color: "#172039" }}>Company Liability:</strong> The Company is not liable for any loss, damage, or theft of goods during 
transit unless caused by gross negligence or willful misconduct of the logistics partner.
                        </p>
                        <p><strong style={{ color: "#172039" }}>Insurance</strong></p>
                        <ul className='Bullets'>
                            <li>For consignments valued above INR 15,000, Users must secure adequate insurance.</li>
                            <li>Users are solely responsible for filing insurance claims in the event of damage or loss.</li>
                        </ul>
                        <p><strong style={{ color: "#172039" }}>Exclusions from Liability:</strong> The Company shall not be held responsible for:
                        </p>
                        <ul className='Bullets'>
                            <li>Improper packaging by the User.</li>
                            <li>Loss of prohibited items.</li>
                            <li>Delays due to force majeure events.</li>
                        </ul>
                    </div>

                    <div className="blogContent">
                        <h2> Force Majeure
                        </h2>
                        <p>The Company shall not be held liable for delays or failure to perform obligations due to 
circumstances beyond its control, including but not limited to natural disasters, strikes, 
accidents, or technical disruptions.</p>
                    </div>

                    <div className="blogContent">
                        <h2>Dispute Resolution</h2>
                        <p> Complaint Resolution: For any issues related to shipping and delivery, Users can contact 
our support team at info@iline.ai. The Company will resolve disputes within 15 business days 
of receiving the complaint.</p>
<p>Jurisdiction: All disputes shall be governed by the laws of India and fall under the 
jurisdiction of Noida, Uttar Pradesh.</p>
                    </div>

                    <div className="blogContent">
                        <h2>Contact Us
                        </h2>
                        <p>For inquiries related to shipping and delivery, please reach out to:
                        </p>
                        <ul>
                            <li><strong style={{ color: "#172039" }}>I-LINE.AI SOLUTIONS PRIVATE LIMITED</strong></li>
                            <li><strong style={{ color: "#172039" }}>Address:</strong> D-9, Sector-3, Noida, Gautam Buddha Nagar, Uttar Pradesh, India-201301
                            </li>
                            <li><strong style={{ color: "#172039" }}>Email:</strong> info@iline.ai</li>
                        </ul>
                        <p className='mb-0'>By using our platform and services, you agree to the terms outlined in this Shipping and Delivery 
                        Policy. The Company reserves the right to update or modify this policy at its sole discretion.</p>
                    </div>
                </div>

            </section>
            <Footer />

        </>
    )
}

export default Shipping
